import { AbstractPmsApiService } from "./abstract.service";
import { RatingFactors } from "../models";

/**
 * @class RatingFactorsPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<RatingFactors>}
 */
export class RatingFactorsPmsApiService extends AbstractPmsApiService {
  /**
   * @type {string}
   * @protected
   */
  get urlPattern() {
    return "/reservation/:reservationId/guest-rates";
  }

  /**
   * @param {Object.<string, *>} attributes
   * @returns {RatingFactors}
   * @protected
   */
  newModel(attributes, ...params) {
    return new RatingFactors(attributes);
  }

  getRatingFactors(reservationId) {
    const url = `${process.env.API_URL}/reservation/${reservationId}/rating-factors`;

    return this.http
      .get(url, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }

  get(reservationId) {
    const url = this.url({ reservationId: reservationId });

    return this.http
      .get(url, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }

  save(reservationId, guest_id, factors) {
    const url = this.url({ reservationId: reservationId });
    //const url = `https://staging-backend.mabeet.com/api/reservation/${reservation_id}/guest-rates`;

    return this.http
      .post(
        url,
        {
          guest_id: guest_id,
          factors: factors,
        },
        {
          headers: this.authHeaders,
        }
      )
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/rating-factors.service.js